module.exports = "<div *ngIf=\"currentUser\">    \n    <h1>Hi {{currentUser.firstName}}!</h1>\n    <p>You're logged in with Facebook!!</p>\n</div>\n"